import {
  SET_ACCOUNT_TYPE_LIST,
  LOADING_ACCOUNT_TYPE_LIST,
  SET_ACCOUNT_TYPE_LIST_DEMO,
  SET_MODAL_BONUS,
  UPDATE_MODAL_CAMPIAGN,
  UPDATE_MODAL_OPEN_ACCOUNT,
  UPDATE_MODAL_OPEN_ACCOUNT_ALERT,
} from "../types";

const INITIALIZE_STATE = {
  accountTypeList: null,
  accountTypeListDemo: null,
  LOADING_ACCOUNT_TYPE_LIST: false,
  modalbonus: false,
  modalClosecampaign: false,
  modalOpenAccount: {
    account_type: null,
    isOpen: false,
    isCoupon: false,
  },
  modalAlertOpenAccount: false,
};

export default (state = INITIALIZE_STATE, action) => {
  switch (action.type) {
    case SET_ACCOUNT_TYPE_LIST:
      return {
        ...state,
        loading: false,
        accountTypeList: action.payload,
      };
    case SET_MODAL_BONUS:
      return {
        ...state,
        loading: false,
        modalbonus: action.payload,
      };
    case UPDATE_MODAL_CAMPIAGN:
      return {
        ...state,
        loading: false,
        modalClosecampaign: action.payload,
      };
    case UPDATE_MODAL_OPEN_ACCOUNT:
      return {
        ...state,
        loading: false,
        modalOpenAccount: {
          account_type: action.payload.account_type,
          isOpen: action.payload.isOpen,
          isCoupon: action.payload.isCoupon,
        },
      };
    case UPDATE_MODAL_OPEN_ACCOUNT_ALERT:
      return {
        ...state,
        loading: false,
        modalAlertOpenAccount: action.payload,
      };
    case SET_ACCOUNT_TYPE_LIST_DEMO:
      return {
        ...state,
        loading: false,
        accountTypeListDemo: action.payload,
      };
    case LOADING_ACCOUNT_TYPE_LIST:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
};
